import { Tag } from 'antd';
import React, { ReactElement } from 'react';

import {
  BooleanChip,
  CurrencyChip,
  DateChip,
  DateTimeChip,
  ImageChip,
  IntegerChip,
  LinkChip,
  NumberChip,
  FileChip,
} from './FieldTypeChips';

interface FieldTypeProps {
  type: string;
}

function FieldType({ type }: FieldTypeProps): ReactElement {
  let fieldType: ReactElement;

  switch (type) {
    case 'BOOLEAN':
      fieldType = <BooleanChip>Boolean</BooleanChip>;
      break;
    case 'CURRENCY':
      fieldType = <CurrencyChip>Currency</CurrencyChip>;
      break;
    case 'DATE':
      fieldType = <DateChip>Date</DateChip>;
      break;
    case 'DATETIME':
      fieldType = <DateTimeChip>Date Time</DateTimeChip>;
      break;
    case 'IMAGE':
      fieldType = <ImageChip>Image</ImageChip>;
      break;
    case 'INTEGER':
      fieldType = <IntegerChip>Integer</IntegerChip>;
      break;
    case 'LINK':
      fieldType = <LinkChip>Link</LinkChip>;
      break;
    case 'NUMBER':
      fieldType = <NumberChip>Number</NumberChip>;
      break;
    case 'OBJECT':
      fieldType = <Tag color="blue">Object</Tag>;
      break;
    case 'FILE':
      fieldType = <FileChip>File</FileChip>;
      break;
    case 'TEXT':
      fieldType = <Tag color="magenta">Text</Tag>;
      break;
    default:
      fieldType = <Tag>Text</Tag>;
  }
  return fieldType;
}

export default FieldType;
